module.exports = __webpack_public_path__ + "img/APP1.77b4daa8.jpg";